import { recordFromSnapshot } from 'utils/firebaseUtils'
import _ from 'lodash'
// import { initDaySliderValues } from './PlanningHelper'
import { selectCurrentPricing } from './settings'
// import moment from 'moment'
// ------------------------------------
// Constants
// ------------------------------------
export const CREATE_PRICING_ERROR = 'CREATE_PRICING_ERROR'
export const CREATE_PRICING_SUCCESS = 'CREATE_PRICING_SUCCESS'
export const DELETE_PRICING_ERROR = 'DELETE_PRICING_ERROR'
export const DELETE_PRICING_SUCCESS = 'DELETE_PRICING_SUCCESS'
export const UPDATE_PRICING_ERROR = 'UPDATE_PRICING_ERROR'
export const UPDATE_PRICING_SUCCESS = 'UPDATE_PRICING_SUCCESS'
export const SELECT_PRICING = 'SELECT_PRICING'
// ------------------------------------
// Logic Actions
// ------------------------------------

// export function selectCurrentPricing (pricing) {
//   return (dispatch, getState) => {
//     dispatch({type : SELECT_PRICING, payload : pricing})
//   }
// }
export function updatePlanning(pricing, changes) {
  return (dispatch, getState) => {
    dispatch(updatePricing(pricing, { changes }))
  }
}
// ------------------------------------
// Basic Actions
// ------------------------------------
export function createPricing(pricing) {
  return (dispatch, getState) => {
    const { firebase } = getState()
    firebase.child('pricings').push(pricing, error => {
      if (error) {
        console.error('ERROR @ createPRICING :', error)
        dispatch({
          type: CREATE_PRICING_ERROR,
          payload: error
        })
      }
    })
  }
}

export function deletePricings(pricings) {
  return (dispatch, getState) => {
    const { firebase } = getState()
    pricings = _.isArray(pricings) ? pricings : [pricings]
    let fanout = {}
    for (let i = 0; i < pricings.length; i++) {
      fanout[`pricings/${pricings[i].key}`] = null
    }
    firebase.update(fanout, error => {
      if (error) {
        console.error('ERROR @ deletePRICING :', error)
        dispatch({
          type: DELETE_PRICING_ERROR,
          payload: error
        })
      }
    })
  }
}

export function updatePricing(pricing, changes) {
  return (dispatch, getState) => {
    const { firebase } = getState()
    firebase.child('pricings/' + pricing.key).update(changes, error => {
      if (error) {
        console.error('ERROR @ updatePricing :', error)
        dispatch({
          type: UPDATE_PRICING_ERROR,
          payload: error
        })
      }
    })
  }
}

export function registerPricingsListeners() {
  return (dispatch, getState) => {
    const { firebase } = getState()
    const ref = firebase.child('pricings')
    ref.orderByChild('name').on('child_added', snapshot => {
      let pricing = recordFromSnapshot(snapshot)
      dispatch({
        type: CREATE_PRICING_SUCCESS,
        payload: pricing
      })
    })

    ref.on('child_changed', snapshot => {
      dispatch({
        type: UPDATE_PRICING_SUCCESS,
        payload: recordFromSnapshot(snapshot)
      })
      // TODO: Update Pricing in currentTransactions
      // dispatch(updateTransactionsWithPricing(recordFromSnapshot(snapshot)))
    })

    ref.on('child_removed', snapshot =>
      dispatch({
        type: DELETE_PRICING_SUCCESS,
        payload: recordFromSnapshot(snapshot)
      })
    )
  }
}

export const actions = {
  createPricing,
  updatePricing,
  registerPricingsListeners,
  selectCurrentPricing
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [SELECT_PRICING]: (state, action) =>
    Object.assign({}, state, { currentPricing: action.payload }),
  [CREATE_PRICING_SUCCESS]: (state, action) => {
    let list
    let tmpList = state.list.slice()
    tmpList = tmpList.filter(pricing => pricing.key === action.payload.key)
    if (tmpList.length === 0) {
      list = [...state.list, action.payload]
    } else {
      list = [...state.list]
    }
    return Object.assign({}, state, { list: list })
  },
  [CREATE_PRICING_ERROR]: (state, action) =>
    Object.assign({}, state, { error: action.payload }),
  [UPDATE_PRICING_SUCCESS]: (state, action) =>
    Object.assign({}, state, {
      list: state.list.map(pricing => {
        return pricing.key === action.payload.key ? action.payload : pricing
      })
    }),
  [UPDATE_PRICING_ERROR]: (state, action) =>
    Object.assign({}, state, { error: action.payload }),
  [DELETE_PRICING_SUCCESS]: (state, action) =>
    Object.assign({}, state, {
      list: state.list.filter(pricing => {
        return pricing.key !== action.payload.key
      })
    }),
  [DELETE_PRICING_ERROR]: (state, action) =>
    Object.assign({}, state, { error: action.payload })
}
// ------------------------------------
// Reducer
// ------------------------------------
const initialState = { list: [], currentPricing: {} }
export default function pricingReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/redux/modules/pricing.js